/* ---------------------------------------------------------------------------
   Count-up stats
   Animates each [data-count-up] from zero to the number already rendered in
   the markup. The final value is server-rendered, so if this script never
   runs the section still reads correctly.
   Modes come from data-count-mode on the section: off | once | always.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Group separators we understand: comma, plain space, non-breaking space. */
  var GROUP = /[,  ]/;
  var GROUP_ALL = /[,  ]/g;

  /* Finds the number inside the text and remembers everything around it, so
     "1000h", "$25,000", "4.8/5" and "25 000 hours" all animate while keeping
     their prefix, suffix, grouping and decimal places.
     The pattern only swallows a space when exactly three digits follow it,
     which is what separates "25 000" (one number) from "1000 h" (number then
     suffix). */
  function parseTarget(str) {
    var s = String(str);
    var m = s.match(/-?\d[\d,]*(?:[  ]\d{3})*(?:\.\d+)?/);
    if (!m) return null;
    var raw = m[0];
    var sep = raw.match(GROUP);
    var plain = raw.replace(GROUP_ALL, '');
    var dot = plain.indexOf('.');
    var value = parseFloat(plain);
    if (isNaN(value)) return null;
    return {
      value: value,
      decimals: dot > -1 ? plain.length - dot - 1 : 0,
      groupChar: sep ? sep[0] : '',
      prefix: s.slice(0, m.index),
      suffix: s.slice(m.index + raw.length)
    };
  }

  function format(n, spec) {
    var s = spec.decimals ? n.toFixed(spec.decimals) : String(Math.round(n));
    if (spec.groupChar) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, spec.groupChar);
      s = parts.join('.');
    }
    return spec.prefix + s + spec.suffix;
  }

  function Counter(el, duration) {
    this.el = el;
    this.duration = duration;
    this.spec = parseTarget(el.getAttribute('data-count-value') || el.textContent);
    this.raf = null;
  }

  Counter.prototype.settle = function () {
    if (this.spec) this.el.textContent = format(this.spec.value, this.spec);
  };

  Counter.prototype.run = function () {
    var self = this;
    var spec = this.spec;
    if (!spec) return;
    if (reduced || !this.duration) { this.settle(); return; }
    if (this.raf) window.cancelAnimationFrame(this.raf);

    var start = null;
    this.el.textContent = format(0, spec);

    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / self.duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      self.el.textContent = format(spec.value * eased, spec);
      if (p < 1) self.raf = window.requestAnimationFrame(frame);
      else self.settle();
    }
    this.raf = window.requestAnimationFrame(frame);
  };

  function init(section) {
    if (section.hpCountUp) return;
    section.hpCountUp = true;

    var mode = section.getAttribute('data-count-mode') || 'once';
    var duration = parseInt(section.getAttribute('data-count-duration'), 10) || 1600;
    var nodes = [].slice.call(section.querySelectorAll('[data-count-up]'));
    if (!nodes.length) return;

    var counters = nodes.map(function (n) { return new Counter(n, duration); });

    if (mode === 'off') return;

    if (!('IntersectionObserver' in window)) {
      counters.forEach(function (c) { c.run(); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = nodes.indexOf(entry.target);
        if (i < 0) return;
        if (entry.isIntersecting) {
          counters[i].run();
          if (mode === 'once') io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  function boot(scope) {
    var root = scope || document;
    [].slice.call(root.querySelectorAll('[data-count-mode]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* theme editor */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
